/** @jsx h */
// @flow
import { h, VNode } from 'preact';
import { styled } from 'goober';

const FixedBottomContainerDiv = styled('div')`
  width: 100%;
  max-width: 100%;
  background-color: #ffffff;
  padding: 14px 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  box-shadow: 5px 0px 13px rgba(0, 0, 0, 0.25);
`;

const FixedBottomContainer = ({ children }: { children: VNode }) => {
  return <FixedBottomContainerDiv>{children}</FixedBottomContainerDiv>;
};
export default FixedBottomContainer;



// WEBPACK FOOTER //
// ./UiComponents/FixedBottomContainer.js